import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import RoutesConst from "./consts/RoutesConst";
import Homepage from "./pages/Homepage/Homepage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import ServiceAreaPage from "./pages/ServiceAreaPage/ServiceAreaPage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import LifeguardPage from "./pages/LifeguardPage/LifeguardPage";
import ReviewsPage from "./pages/ReviewsPage/ReviewsPage";
import EnrollPage from "./pages/EnrollPage/EnrollPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Routes>
        <Route path={RoutesConst.ABOUT_US} element={<AboutUsPage />} />
        <Route path={RoutesConst.ENROLL} element={<EnrollPage />} />
        <Route index path={RoutesConst.DEFAULT} element={<Homepage />} />
        <Route path={RoutesConst.LIFEGUARDS} element={<LifeguardPage />} />
        <Route
          path={RoutesConst.PRIVACY_POLICY}
          element={<PrivacyPolicyPage />}
        />
        <Route path={RoutesConst.REVIEWS} element={<ReviewsPage />} />
        <Route path={RoutesConst.SERVICES} element={<ServicesPage />} />
        <Route path={RoutesConst.SERVICE_AREA} element={<ServiceAreaPage />} />
      </Routes>
    );
  }
}
